import { render, staticRenderFns } from "./RecipeStatistic.vue?vue&type=template&id=7c66597e&"
import script from "./RecipeStatistic.vue?vue&type=script&lang=js&"
export * from "./RecipeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports